/**
 * Immutable updates for organization lists after billing API results.
 */

export function applySubscriptionNoticePatch(organizationsList, organizationPatch) {
  const { id, generation_allowed, notice_code, short_notice_deadline } =
    organizationPatch;
  return organizationsList.map((organization) => {
    if (organization.id !== id) return organization;
    return {
      ...organization,
      generation_allowed,
      notice_code,
      short_notice_deadline,
    };
  });
}

export function applyMonthlyReportPlanPatch(
  organizationsList,
  organizationId,
  plan,
) {
  return organizationsList.map((organization) => {
    if (organization.id !== organizationId) return organization;
    return {
      ...organization,
      monthly_report: {
        ...organization.monthly_report,
        plan,
      },
    };
  });
}

export function applyDefaultPaymentMethodPatch(
  selectedOrganizationsList,
  organizationId,
  defaultMethodId,
  defaultValue,
) {
  return selectedOrganizationsList.map((organization) => {
    if (organization.id !== organizationId) return organization;
    return {
      ...organization,
      payment_methods: organization.payment_methods.map((method) => ({
        ...method,
        default: method.id === defaultMethodId ? defaultValue : false,
      })),
    };
  });
}

export function replaceOrganizationPaymentMethods(
  organizationsList,
  payload,
) {
  const { id, payment_methods } = payload;
  return organizationsList.map((organization) =>
    organization.id === id ? { ...organization, payment_methods } : organization,
  );
}
